var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-datepicker',{class:`surveyquestion-datepicker ${_vm.importedDataStyling}`,attrs:{"date-format-options":{
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },"size":"md","locale":"es","placeholder":"fecha","clear-button":true,"readonly":_vm.readOnlyInputs},on:{"input":_vm.onInputChanged},model:{value:(_vm.dateValue),callback:function ($$v) {_vm.dateValue=$$v},expression:"dateValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }